import { Table, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { TableProps } from 'antd';
import { useState } from 'react';

interface DataTableProps<T> extends Omit<TableProps<T>, 'pagination'> {
  total?: number;
  page?: number;
  perPage?: number;
  onPageChange?: (page: number, perPage: number) => void;
  searchPlaceholder?: string;
  onSearch?: (value: string) => void;
  extra?: React.ReactNode;
}

export function DataTable<T extends object>({
  total = 0,
  page = 1,
  perPage = 20,
  onPageChange,
  searchPlaceholder = 'Search...',
  onSearch,
  extra,
  ...tableProps
}: DataTableProps<T>) {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (value: string) => {
    setSearchValue(value);
    onSearch?.(value);
  };

  return (
    <div>
      {(onSearch || extra) && (
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', gap: 16 }}>
          {onSearch ? (
            <Input.Search
              placeholder={searchPlaceholder}
              allowClear
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onSearch={handleSearch}
              style={{ maxWidth: 320 }}
              prefix={<SearchOutlined />}
            />
          ) : <div />}
          {extra && <Space>{extra}</Space>}
        </div>
      )}
      <Table<T>
        {...tableProps}
        pagination={{
          current: page,
          pageSize: perPage,
          total,
          showSizeChanger: true,
          showTotal: (t) => `${t} total`,
          onChange: (p, ps) => onPageChange?.(p, ps),
        }}
        size="middle"
        rowKey={(tableProps.rowKey as string) || 'id'}
      />
    </div>
  );
}
